module.exports = __webpack_public_path__ + "static/media/WAStateElection2025LogoDesktop.a5fdeff4.svg";